const onBoardingsEndpoints = {
  base: "/v1/cms/on-boardings",
  byId: (id) => `/v1/cms/on-boardings/${id}`,
};

export default onBoardingsEndpoints;
